import React, { useEffect } from "react";
import {
  AttachmentSection,
  Button,
  Divider,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { RecordStatus } from "../../../../../../../assets/data/enumData";

const AddI94 = ({ isEdit, onClose, isOpen, initialData }) => {
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        i94Number: "",
        dateOfLastArrival: null,
        statusExpiryDate: null,
        status: "",
        priorityDate: null,
        attachments: [
          {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            chooseFiles: [],
          },
        ],
      },
      {
        i94Number: { type: "text", required: true },
        attachments: [ { chooseFiles: { type: "file" } } ]
      }
    );

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form data:", formData);
      onClose();
    } else {
      console.log("error:", errors);
    }
  };

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };

  useEffect(() => {
    if (isOpen) {
      if (isEdit && initialData) {
        setFormData({
          i94Number: initialData.i94Number || "",
          dateOfLastArrival: initialData.dateOfLastArrival || null,
          statusExpiryDate: initialData.statusExpiryDate || null,
          status: initialData.status || "",
          priorityDate: initialData.priorityDate || null,
          attachments: initialData.attachments || [
            {
              id: uuidv4(),
              attachmentName: "",
              attachmentComments: "",
              chooseFiles: [],
            },
          ],
        });
      } else {
        // reset when adding
        setFormData({
          i94Number: "",
          dateOfLastArrival: null,
          statusExpiryDate: null,
          status: "",
          priorityDate: null,
          attachments: [
            {
              id: uuidv4(),
              attachmentName: "",
              attachmentComments: "",
              chooseFiles: [],
            },
          ],
        });
      }
    }
  }, [isOpen, isEdit, initialData]);

  return (
    <Modal
      title={isEdit ? "EDIT I-94 DETAILS" : "ADD I-94 DETAILS"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-7xl"
    >
      <div>
        <div className="grid grid-cols-2 xl:grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
          <FormFieldSet
            type="text"
            title={"I-94 Number"}
            placeholder="Select Invoice Category"
            value={formData.i94Number}
            onChange={(value) => handleChange("i94Number", value)}
            error={errors.i94Number}
          />
          <FormFieldSet
            type="datepicker"
            title={"Date of Last Arrival"}
            placeholder="Select Date of Last Arrival"
            value={formData.dateOfLastArrival}
            onChange={(value) => handleChange("dateOfLastArrival", value)}
            error={errors.dateOfLastArrival}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Status Expiry Date"}
            placeholder="Select tatus Expiry Date"
            value={formData.statusExpiryDate}
            onChange={(value) => handleChange("statusExpiryDate", value)}
            error={errors.statusExpiryDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title={"Status"}
            placeholder="Select Status"
            value={formData.status}
            onChange={(value) => handleChange("status", value)}
            error={errors.status}
            options={RecordStatus}
          />
          <FormFieldSet
            type="datepicker"
            title={"Priority Date"}
            placeholder="Select Priority Date"
            value={formData.priorityDate}
            onChange={(value) => handleChange("priorityDate", value)}
            error={errors.priorityDate}
            showDropdown={false}
          />
        </div>
        <div className="mt-6 ">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ATTACHMENTS"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>
        <div>
          <div className="max-w-7xl">
            <AttachmentSection
              attachments={formData.attachments}
              onChange={(newAttachments) =>
                setFormData({ ...formData, attachments: newAttachments })
              }
              getAttachmentError={getAttachmentError}
              showNameField={true}
              showCommentsField={true}
            />
          </div>
        </div>

        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button
            title={isEdit ? "Update" : "Submit"}
            onClick={() => handleSave()}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AddI94;
